export const CreateProjectDealType = {
  NEW_CONSTRUCTION: 'NEW_CONSTRUCTION',
  OPERATING_PROJECT_SALE: 'OPERATING_PROJECT_SALE',
  TAX_CREDIT_SALE: 'TAX_CREDIT_SALE',
} as const;

export const CreateProjectDealTypeDisplay = {
  [CreateProjectDealType.NEW_CONSTRUCTION]: 'New installation',
  [CreateProjectDealType.OPERATING_PROJECT_SALE]: 'Operating project sale',
  [CreateProjectDealType.TAX_CREDIT_SALE]: 'Tax credit sale',
} as const;

export const CreateProjectDealTypeRadioOptions = [
  {
    value: CreateProjectDealType.NEW_CONSTRUCTION,
    label: CreateProjectDealTypeDisplay[CreateProjectDealType.NEW_CONSTRUCTION],
  },
  {
    value: CreateProjectDealType.OPERATING_PROJECT_SALE,
    label: CreateProjectDealTypeDisplay[CreateProjectDealType.OPERATING_PROJECT_SALE],
  },
  {
    value: CreateProjectDealType.TAX_CREDIT_SALE,
    label: CreateProjectDealTypeDisplay[CreateProjectDealType.TAX_CREDIT_SALE],
  },
];

export const CreateProjectTypes = {
  MARKET_QUOTE: 'MARKET_QUOTE',
  PROJECT: 'PROJECT',
};

export const CreateProjectTypesDisplay = {
  [CreateProjectTypes.MARKET_QUOTE]: 'Get a quick pricing estimate',
  [CreateProjectTypes.PROJECT]: 'Prepare a project for investors',
};

export const CreateProjectTypesRadioOptions = [
  { value: CreateProjectTypes.MARKET_QUOTE, label: CreateProjectTypesDisplay[CreateProjectTypes.MARKET_QUOTE] },
  { value: CreateProjectTypes.PROJECT, label: CreateProjectTypesDisplay[CreateProjectTypes.PROJECT] },
];


